<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-top">
        <div class="footer-logo">
          <img src="@/assets/daohan-logo.png" alt="道晗漫画平台" class="logo-image">
        </div>
        <div class="footer-links">
          <div class="link-group">
            <h4>关于我们</h4>
            <ul>
              <li><router-link to="/about">关于我们</router-link></li>
            </ul>
          </div>
          <div class="link-group">
            <h4>版权服务</h4>
            <ul>
              <li><router-link to="/copyright">版权声明</router-link></li>
              <li><router-link to="/copyright#complaint">侵权举报</router-link></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="copyright">
        <p class="rights-summary">本站内容受版权保护，未经授权不得转载、复制或传播。<router-link to="/copyright#complaint">发现侵权，提交举报</router-link></p>
        <p>© 2026 道晗漫画平台 · 北京道晗科技有限责任公司 All Rights Reserved</p>
        <p class="icp"><a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2026022969号-1</a></p>
        <p>地址：北京市朝阳区豆各庄黄厂西路1号C5栋五层5365</p>
        <p>电话：15311160987</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
}
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.footer {
  background:
    radial-gradient(circle at 12% 0%, rgba(255, 204, 102, 0.12), transparent 28%),
    linear-gradient(180deg, rgba(11, 14, 25, 0.94), rgba(5, 7, 13, 0.98));
  color: #fff;
  padding: 34px 0 22px;
  margin-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 40px;
}

.footer-logo {
  margin-right: 0;
  background: rgba(255, 255, 255, 0.92);
  padding: 8px 12px;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(0, 0, 0, 0.32);
}

.logo-image {
  width: 128px;
  height: auto;
  border-radius: 6px;
  display: block;
}

.footer-links {
  display: flex;
  gap: 48px;
}

.link-group {
  text-align: left;
}

.link-group h4 {
  margin-bottom: 15px;
  font-size: 18px;
  color: #ffffff;
}

.link-group ul {
  list-style: none;
  padding: 0;
}

.link-group li {
  margin-bottom: 10px;
}

.link-group a {
  color: #aab5d4;
  text-decoration: none;
  font-size: 14px;
}

.link-group a:hover {
  color: #fff;
}

.copyright {
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  color: rgba(230, 238, 255, 0.66);
  font-size: 14px;
  line-height: 1.8;
}

.rights-summary {
  margin-bottom: 10px;
  color: rgba(230, 238, 255, 0.82);
}

.rights-summary a {
  margin-left: 6px;
  color: #23d3ee;
  text-decoration: none;
}

.rights-summary a:hover {
  color: #ffcc66;
}

.icp {
  margin-top: 10px;
  font-size: 12px;
}

.icp a {
  color: rgba(230, 238, 255, 0.72);
  text-decoration: none;
}

.icp a:hover {
  color: #fff;
}

@media (max-width: 720px) {
  .footer-top {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .link-group {
    text-align: center;
  }

  .footer-links {
    flex-direction: column;
    gap: 22px;
  }
}
</style> 
